import { getAccountLayout } from "@/account/AccountLayout";
import AccountInformation from "@/account/profile/AccountInformation";
import { PageTitle } from "@/account/typography";
import Billing from "@/account/profile/Billing";
import Vouchers from "@/account/profile/Vouchers";
import { getReferrals, getVouchers } from "lib/api/account";
import Referrals from "@/account/profile/Referrals";
import Head from "next/head";
import { useContext, useEffect } from "react";
import { AccountContext } from "contexts/AccountProvider";
import { withRouter } from "next/router";
import { useToasts } from "react-toast-notifications";
import { formatToast } from "/utils";
import SocialAccounts from "@/account/profile/SocialAccounts";
import { AdminContext } from "contexts/AdminProvider";
import CardEmailVerification from "@/account/EmailVerification/CardEmailVerification";
import { AuthContext } from "contexts/AuthProvider";

const Profile = ({ vouchers, referrals, router }) => {
  const { refreshAuth, refreshPaymentMethods } = useContext(AccountContext);
  const { isVerified } = useContext(AuthContext);

  const { isFeatureOn } = useContext(AdminContext);
  const showSocialAccounts = isFeatureOn("social-accounts");

  useEffect(() => {
    refreshAuth();
    refreshPaymentMethods();
  }, []);

  const { addToast } = useToasts();

  return (
    <div>
      <Head>
        <title key="title">Account Details</title>
        <meta name="robots" content="noindex" />
      </Head>
      <PageTitle className={"max:md:hidden mb-4"}>My Profile</PageTitle>
      <div className={"grid gap-4"}>
        {!isVerified ? <CardEmailVerification /> : null}
        <AccountInformation />
        {showSocialAccounts && <SocialAccounts />}
        <Billing />
        <Referrals {...referrals} />
        <Vouchers {...vouchers} />
      </div>
    </div>
  );
};

export const getServerSideProps = async (ctx) => {
  const [vouchers, referrals] = await Promise.all([
    getVouchers(ctx),
    getReferrals(ctx),
  ]);

  const { query } = ctx;

  return {
    props: {
      vouchers,
      referrals,
    },
  };
};

const ProfileWithRouter = withRouter(Profile);

ProfileWithRouter.getLayout = getAccountLayout;

export default ProfileWithRouter;
